namespace e5 {
    export interface IAnimatorKeyFrame {
        frame: number;
        label?: string;
        title?: string;
        stop?: boolean;
    }
    interface IAnimatorKeyFrameInternal extends IAnimatorKeyFrame {
        controlEntry: JQuery;
    }
    export interface IAnimatorImage {
        url: string;
        frame: number;
    }
    interface IAnimatorImageInternal extends IAnimatorImage {
        image: HTMLImageElement;
    }
    export interface IAnimatorOptions {
        frameWidth: number;
        frameHeight: number;
        totalFrames: number;
        scaling?: "original" | "cover" | "contains";
        imagePattern?: string;
        imagePatternOffset?: number;
        imagePatternPadding?: { count: number; char: string };
        images?: IAnimatorImage[];
        canvasPosition?: string | "center";
        fullscreen?: boolean;
        keyFrames?: IAnimatorKeyFrame[];
        fps?: number;
        loop?: boolean;
        autoPlay?: boolean;
        scroll?: boolean;
        hiddenClass?: string;
        baseIndex?: number;
        useTweenMax?: boolean;
    }
    export class Animator {
        public static DEFAULT_OPTIONS: IAnimatorOptions = {
            totalFrames: 0,
            frameWidth: 0,
            frameHeight: 0,
            scaling: "cover",
            canvasPosition: "center",
            fullscreen: true,
            keyFrames: [],
            fps: 24,
            loop: false,
            autoPlay: false,
            scroll: true,
            hiddenClass: "animation-hidden",
            baseIndex: 0,
            useTweenMax: false
        };

        public element: JQuery;

        private _frame: number = -1;
        private _totalFrames: number;
        private _frames: IAnimatorImageInternal[] = [];
        private _canvas: HTMLCanvasElement;
        private _ctx: CanvasRenderingContext2D;
        private _loadedCount: number = 0;
        private _overlays: JQuery;
        private _options: IAnimatorOptions;
        private _canvasHolder: JQuery;
        private _overlay: JQuery;
        private _progress: JQuery;
        private _progressThumb: JQuery;
        private _fullscreenButton: JQuery;
        private _playing: boolean = false;
        private _direction: "forward" | "backward" = "forward";
        private _control: JQuery;
        private _keyFrames: IAnimatorKeyFrameInternal[] = [];
        private _currentSelectedKeyFrame: IAnimatorKeyFrameInternal = null;
        private _tweenInterval: number = -1;

        constructor(selector: string, options: IAnimatorOptions) {
            this.element = $(selector);
            options = $.extend({}, Animator.DEFAULT_OPTIONS, options) as IAnimatorOptions;
            this._options = options;

            this._totalFrames = options.totalFrames;
            this._canvasHolder = $("<div class='animation-canvas-holder'></div>");
            this._canvasHolder.attr("data-position", options.canvasPosition);
            this.element.prepend(this._canvasHolder);

            this._progress = $("<div class='animation-progress'></div>");
            this.element.append(this._progress);

            this._progressThumb = $("<div class='animation-progress-thumb'></div>");
            this._progress.append(this._progressThumb);

            this._canvas = document.createElement("canvas");
            this._canvas.classList.add("animation-canvas");
            this._canvasHolder.append(this._canvas);
            this._canvas.width = options.frameWidth;
            this._canvas.height = options.frameHeight;

            this._ctx = this._canvas.getContext("2d");

            this._overlay = $(".animation-overlay", this.element);

            //TODO: on top is not correct!
            this.element.append(this._overlay);

            this._control = $("<div class='animation-control'></div>");
            this._control.addClass("animation-hidden");
            this.element.append(this._control);

            this._options.keyFrames.sort((a, b) => {
                return a.frame - b.frame;
            });

            if (this._options.keyFrames.length > 0) {
                var keyFrameList = $("<div class='animation-control-keyframe-list'></div>");
                for (var keyFrame of this._options.keyFrames) {
                    var entry = $("<div class='animation-control-keyframe'></div>");
                    if (keyFrame.title) {
                        var title = $("<div class='animation-control-keyframe-title'></div>");
                        title.html(keyFrame.title);
                        entry.append(title);
                    }
                    entry.attr("data-tweento", keyFrame.frame);
                    keyFrameList.append(entry);

                    this._keyFrames.push(
                        {
                            frame: keyFrame.frame,
                            label: keyFrame.label,
                            title: keyFrame.title,
                            stop: keyFrame.stop,
                            controlEntry: entry
                        });
                }
                this._control.append(keyFrameList);
            }

            var imageDatas: IAnimatorImageInternal[];
            if (options.imagePattern) {
                imageDatas = [];
                var pattern = options.imagePattern;
                var patternPadding = options.imagePatternPadding;
                var patternOffset = options.imagePatternOffset != undefined ? options.imagePatternOffset : 0;
                for (var i = 0; i < this._totalFrames; ++i) {
                    var num = (i + patternOffset).toString();
                    if (patternPadding) {
                        num = e5.Text.fillHead(num, patternPadding.count, patternPadding.char);
                    }
                    imageDatas.push({
                        url: pattern.replace("{number}", num),
                        frame: i + this._options.baseIndex,
                        image: document.createElement("img")
                    });
                }
            }
            else {
                imageDatas = [];
                for (var im of options.images)
                    imageDatas.push({
                        url: im.url,
                        frame: im.frame,
                        image: document.createElement("img")
                    });
            }

            $("[data-framerange]", this.element).each((index, element) => {
                var e = $(element);
                var keyFrame = this.getKeyFrame(e.attr("data-framerange"));
                if (keyFrame) {
                    e.attr("data-framestart", keyFrame.frame);
                    e.attr("data-frameend", this.getEndFrame(keyFrame));
                }
            });

            this._overlays = $("[data-framestart],[data-frameend]", this.element);
            this._overlays.addClass(this._options.hiddenClass);

            for (var imageData of imageDatas) {
                this.loadImage(imageData);
            }

            this.resize();
            $(window).resize(() => this.resize());

            if (options.fullscreen && e5.FullscreenUtil.isSupported) {
                this._fullscreenButton = $("<div class='animation-fullscreen-button'></div>");
                this.element.append(this._fullscreenButton);
                this._fullscreenButton.click(() => e5.FullscreenUtil.toggle(this.element[0]));
                e5.FullscreenUtil.onChange.add((fullscreen) => this.element.toggleClass("fullscreen", fullscreen));
            }

            this.element.on("click", "[data-tweento]", (e) => {
                var frame = parseInt($(e.currentTarget).attr("data-tweento"));
                this.tweenTo(frame);
            });

            if (this._options.scroll && this._options.keyFrames.length > 0) {
                this.element.bind("mousewheel DOMMouseScroll", (evt: any) => {
                    evt.originalEvent.preventDefault();
                    var delta = evt.originalEvent.detail;
                    if (!delta)
                        delta = evt.originalEvent.wheelDelta / -40;
                    if (delta > 0)
                        this.next();
                    else
                        this.previous();
                });
            }
        }

        private getKeyFrame(label: string): IAnimatorKeyFrameInternal {
            for (var keyFrame of this._keyFrames)
                if (keyFrame.label == label)
                    return keyFrame;
            return null;
        }

        private getEndFrame(keyFrame: IAnimatorKeyFrameInternal): number {
            var index = this._keyFrames.indexOf(keyFrame);
            var keyFrameNext = this._keyFrames[index + 1];
            if (!keyFrameNext)
                return this.getLastFrame();
            return keyFrameNext.frame - 1;
        }

        private getLastFrame(): number {
            return (this._totalFrames - 1) + this._options.baseIndex;
        }

        private getFirstFrame(): number {
            return this._options.baseIndex;
        }

        private previous(): void {
            var index = this._currentSelectedKeyFrame ? this._keyFrames.indexOf(this._currentSelectedKeyFrame) : 0;
            var currentKeyFrame = this._keyFrames[index];
            if (this._frame > currentKeyFrame.frame)
                return;
            index--;
            if (index < 0)
                index = 0;
            var keyFrame = this._keyFrames[index];
            this.tweenTo(keyFrame.frame);
        }

        private next(): void {
            var index = this._currentSelectedKeyFrame ? this._keyFrames.indexOf(this._currentSelectedKeyFrame) : 0;
            index++;
            if (index > this._keyFrames.length - 1)
                index = this._keyFrames.length - 1;
            var keyFrame = this._keyFrames[index];
            this.tweenTo(keyFrame.frame);
        }

        private loadImage(imageData: IAnimatorImageInternal): void {
            var image = imageData.image;
            image.onload = () => this.onImageLoaded(imageData);
            image.onerror = () => this.onImageError(imageData);
            image.src = imageData.url;
            this._frames[imageData.frame] = imageData;
        }

        private onImageError(imageData: IAnimatorImageInternal): void {
            imageData.image = null;
            console.warn("Could not load image for frame", imageData.frame, "URL", imageData.url);
            this._loadedCount++;
            this.checkCompletion();
        }

        private onImageLoaded(imageData: IAnimatorImageInternal): void {
            this._loadedCount++;
            this.checkCompletion();
        }

        private checkCompletion(): void {
            this._progressThumb.css("width", ((this._loadedCount / this._totalFrames) * 100) + "%");
            if (this._loadedCount == this._totalFrames) {
                this.ready();
            }
        }

        private ready(): void {
            this._overlay.removeClass("animation-hidden");
            this._progress.remove();
            if (this._options.autoPlay)
                this.play();
            else
                this.setFrame(this._options.baseIndex);
            this._control.removeClass("animation-hidden");
        }

        private tweenTo(frame: number): void {
            frame = this.clampFrame(frame);
            if (frame == this._frame)
                return;
            var range = Math.max(Math.abs(this._frame - frame), 1);

            if (this._options.useTweenMax) {
                gs.TweenMax.to(this, range / this._options.fps, { setFrame: frame, ease: gs.Linear.easeNone });
            }
            else {
                var time = (range / this._options.fps) * 1000;
                var currentFrame = this._frame;
                var steps = time / range;
                var step = this._frame > frame ? -1 : 1;
                clearInterval(this._tweenInterval);
                this._tweenInterval = <any>setInterval(() => {
                    currentFrame += step;
                    this.setFrame(currentFrame);
                    if (currentFrame == frame)
                        clearInterval(this._tweenInterval);
                }, time / range);
            }
        }

        private clampFrame(frame: number): number {
            return Math.min(Math.max(this._options.baseIndex, Math.round(frame)), (this._totalFrames - 1) + this._options.baseIndex);
        }

        public resize(): void {
            var w = this.element.width();
            var h = this.element.height();
            var scX = w / this._options.frameWidth;
            var scY = h / this._options.frameHeight;
            var sc = 1;

            if (this._options.scaling == "original")
                sc = 1;
            else if (this._options.scaling == "cover")
                sc = Math.max(scX, scY);
            else if (this._options.scaling == "contains")
                sc = Math.min(scX, scY);

            $(this._canvas).css("transform", "scale(" + sc + ")");

            this._canvasHolder.css("width", Math.round(this._options.frameWidth * sc) + "px");
            this._canvasHolder.css("height", Math.round(this._options.frameHeight * sc) + "px");

            //this.drawCurrentImage();
        }

        public play(): void {
            if (this._playing)
                return;
            this._playing = true;
            this.tweenTo(this.getNextStopKeyFrame());
        }

        public setFrame(value: number) {
            value = this.clampFrame(value);

            if (this._frame == value)
                return;
            this._frame = value;

            this._overlays.each((index, element) => {
                var start = parseInt(element.attributes.getNamedItem("data-framestart").value);
                var end = parseInt(element.attributes.getNamedItem("data-frameend").value);
                element.classList.toggle(this._options.hiddenClass, !(value >= start && value <= end));
            });

            this.drawCurrentImage();

            if (this._playing && this._options.loop && this._frame == this.getLastFrame()) {
                this.setFrame(this.getFirstFrame());
                this.tweenTo(this.getNextStopKeyFrame());
            }

            //for (var keyFrame of this._keyFrames) {
            for (var i = this._keyFrames.length - 1; i >= 0; --i) {
                var keyFrame = this._keyFrames[i];
                if (value >= keyFrame.frame) {
                    if (this._currentSelectedKeyFrame != keyFrame) {
                        if (this._currentSelectedKeyFrame) {
                            this._currentSelectedKeyFrame.controlEntry.removeClass("selected");
                        }
                        this._currentSelectedKeyFrame = keyFrame;
                        if (this._currentSelectedKeyFrame) {
                            this._currentSelectedKeyFrame.controlEntry.addClass("selected");
                        }
                    }
                    break;
                }
            }
        }

        private getNextKeyFrame(): number {
            if (this._options.keyFrames.length > 0) {
                for (var keyFrame of this._options.keyFrames) {
                    if (keyFrame.frame > this._frame) {
                        return keyFrame.frame;
                    }
                }
            }

            return this._totalFrames;
        }

        private getNextStopKeyFrame(): number {
            if (this._options.keyFrames.length > 0) {
                for (var keyFrame of this._options.keyFrames) {
                    if (keyFrame.stop && keyFrame.frame > this._frame) {
                        return keyFrame.frame;
                    }
                }
            }
            return this._totalFrames;
        }

        public getFrame(): number {
            return this._frame;
        }

        private drawCurrentImage(): void {
            var imageData = this._frames[this._frame];
            if (imageData && imageData.image && imageData.image.complete)
                this._ctx.drawImage(imageData.image, 0, 0);
        }
    }
}